export default "__VITE_ASSET__CsJKF140__"